// extracted by mini-css-extract-plugin
module.exports = {"root":"SurveyDetailView_root_2lEIn","inner":"SurveyDetailView_inner_1e29g"};